import { CanActivateFn } from '@angular/router';

export const tpaGuard: CanActivateFn = () => {
  let userProfile = JSON.parse(sessionStorage.getItem('user') || '{}');
  if (!userProfile || !userProfile.security || !userProfile.security.terminalAndPrinterTab)
    return false;
  else return true;
};